import { partialRight } from 'lodash-es';
import { onCartTrackEvent } from './onCartTrackEvent';
import { onCartItemCountUpdate } from './onCartItemCountUpdate';
import onLogError from '../../../utils/onLogError';
import {
  startTransaction,
  finishTransaction,
} from '../../../utils/transactionManager';

const cartPageEvent = {
  onTrackEvent: onCartTrackEvent,
  onCartItemCountUpdate: onCartItemCountUpdate,
  onLogError: partialRight(onLogError, (scope) => {
    scope.setTag('module', 'sl-checkout-module');
  }),
  performance: {
    transaction: {
      startTransaction: (options) => {
        return startTransaction({
          ...options,
          module: 'cartV2',
          op: 'cartV2.ui.action',
        });
      },
      finishTransaction,
    },
  },
};

export default cartPageEvent;
